export const LOAD_BALANCE_TIME_SERIES = 'LOAD_BALANCE_TIME_SERIES'
export const RECEIVE_BALANCE_TIME_SERIES = 'RECEIVE_BALANCE_TIME_SERIES'